import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import AutocompleteProduct from "./AutocompleteProduct"
import useSwatches from "./useSwatches"
import { useMemo, useEffect } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {

        useEffect(()=>{
            nostojs(function(api) {
                var request = api.createRecommendationRequest();
                request.addElements(['noresults-nosto-1']);
                request.loadRecommendations();
            });

            document.querySelector("#WebSearchForm > svg").style.backgroundColor = "white";
            document.querySelectorAll("#WebSearchForm > svg path").forEach((p) => {
                p.style.fill = "black";
                p.style.fillOpacity = 0.3;
            })

            document.querySelector("#WebSearchForm > svg").setAttribute("disabled", true);

            document.querySelector(".nosto-autocomplete-wrapper input").addEventListener("keydown", function(e){
                if(e.key == 'Enter'){
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                }
            })

        })

        return (
            <div
                class="ns-autocomplete ns-history-outer ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
                data-nosto-element="autocomplete"
            >
            <div class="ns-w-100">
                <div class="ns-d-flex ns-flex-column">
                    {window.nostoSearchTerms &&
                        <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column">
                            <div class="ns-autocomplete-header">Trending Searches</div>
                            <div class="ns-d-flex ns-flex-row ns-flex-wrap ns-keywords ns-trending-wrapper">
                              {window.nostoSearchTerms?.map((term) => {
                                  var termSlug = term.replaceAll(" ", "+")
                                  return (
                                      <div class="ns-trending">
                                          <a href={`https://bohme.com/search?q=${termSlug}`}>{term}</a>
                                      </div>
                                  )
                              })}
                            </div>
                        </div>
                    }
                    <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column">
                        <div class="ns-autocomplete-header ns-no-results">No results</div>
                    </div>
                    <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                        <div class="nosto_element" id="noresults-nosto-1"></div>
                    </div>
                </div>
            </div>
        </div>
        )
    }

    var { swatchData } = useSwatches();

    
    useEffect(() => {

        if(document.querySelector("#WebSearchForm input").value.length > 1) {
            document.querySelector("#WebSearchForm > svg").style.backgroundColor = "black";
            document.querySelectorAll("#WebSearchForm > svg path").forEach((p) => {
                p.style.fill = "white";
                p.style.fillOpacity = 1;
            })
        } else {
            document.querySelector("#WebSearchForm > svg").style.backgroundColor = "white";
            document.querySelectorAll("#WebSearchForm > svg path").forEach((p) => {
                p.style.fill = "black";
                p.style.fillOpacity = 0.3;
            })
        }

        document.querySelector("#WebSearchForm > svg").addEventListener("click", function(){
            document.querySelector(".ns-autocomplete-submit button").click();
        })

        document.querySelector("#WebSearchForm > svg[disabled='true']")?.removeAttribute("disabled");
    
    }, [products])

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column">
                    {keywords?.hits?.length > 0 && (
                        <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column">
                            <div class="ns-autocomplete-header">Suggestions</div>
                            <div class="ns-d-flex ns-flex-column ns-keywords">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-d-flex ns-flex-row ns-flex-wrap ns-autocomplete-products-wrapper">
                                {products?.hits?.map(hit => {

                                    const groupTag = useMemo(() => hit?.tags1?.find(tag => tag.toLowerCase().includes('ygroup')), []);
                                    const relatedProducts = useMemo(() => {
                                        if (!groupTag) return [];
                                        return swatchData.filter(product =>
                                          product.tags1?.some(tag =>
                                            tag?.toLowerCase().includes(groupTag.toLowerCase())
                                          )
                                        );
                                    }, [swatchData, groupTag]);
                      
                                    return (
                                        <AutocompleteProduct product={hit} key={hit.productId} relatedProducts={ relatedProducts } />
                                    )
                                })}
                            </div>
                            <SubmitButton text="View all search results" />
                        </div>
                    )}
                    <div className="ns-mobile-spacer"></div>
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-keyword-inner">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
